/* Aurelian — theme.js. No dependencies. */
(function () {
  'use strict';

  const t = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const money = (cents) => {
    const fmt = t.moneyFormat || '${{amount}}';
    const num = (cents / 100).toFixed(2);
    const withCommas = num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, withCommas);
  };

  const announce = (msg) => {
    const el = $('#a11y-status');
    if (el) { el.textContent = ''; setTimeout(() => (el.textContent = msg), 60); }
  };

  /* ---------- focus trap + scroll lock ---------- */
  let lastFocused = null;
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function openPanel(el) {
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.removeAttribute('inert');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $('#overlay') && $('#overlay').classList.add('is-active');
    const first = el.querySelector(FOCUSABLE);
    first && first.focus();
    el._trap = (e) => {
      if (e.key === 'Escape') { closePanel(el); return; }
      if (e.key !== 'Tab') return;
      const items = $$(FOCUSABLE, el).filter((n) => n.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', el._trap);
  }

  function closePanel(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    $('#overlay') && $('#overlay').classList.remove('is-active');
    document.removeEventListener('keydown', el._trap);
    lastFocused && lastFocused.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); const p = $('#' + opener.dataset.open); p && openPanel(p); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closePanel(closer.closest('.drawer, .mnav') || $('#' + closer.dataset.close)); return; }
    if (e.target.id === 'overlay') {
      closePanel($('.drawer.is-open')); closePanel($('.mnav.is-open'));
    }
  });

  /* ---------- cart ---------- */
  const Cart = {
    async add(formData) {
      formData.append('sections', 'cart-drawer,cart-count');
      const res = await fetch(t.routes.cart_add_url, {
        method: 'POST', headers: { Accept: 'application/javascript' }, body: formData
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      this.render(data.sections);
      return data;
    },
    async change(body) {
      const res = await fetch(t.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: 'cart-drawer,cart-count,main-cart' }, body))
      });
      const data = await res.json();
      this.render(data.sections);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      return data;
    },
    render(sections) {
      if (!sections) return;
      const swap = (key, selector) => {
        if (!sections[key]) return;
        const incoming = new DOMParser().parseFromString(sections[key], 'text/html').querySelector(selector);
        const current = $(selector);
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      };
      swap('cart-drawer', '#cart-drawer .drawer__inner');
      swap('cart-count', '#cart-bubble');
      swap('main-cart', '#main-cart');
    },
    open() { const d = $('#cart-drawer'); d && openPanel(d); }
  };

  /* ---------- product form ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.errorEl = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
    async onSubmit(e) {
      if (t.cartType !== 'drawer') return;
      e.preventDefault();
      this.button.setAttribute('aria-disabled', 'true');
      const label = this.button.textContent;
      this.button.textContent = '…';
      this.errorEl && (this.errorEl.hidden = true);
      try {
        await Cart.add(new FormData(this.form));
        announce(t.strings.addedToCart);
        Cart.open();
      } catch (err) {
        if (this.errorEl) { this.errorEl.textContent = err.message; this.errorEl.hidden = false; }
      } finally {
        this.button.removeAttribute('aria-disabled');
        this.button.textContent = label;
      }
    }
  }
  customElements.define('product-form', ProductForm);

  /* ---------- variant picker ---------- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.url = this.dataset.url;
      this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      this.addEventListener('change', this.onChange.bind(this));
    }
    get selectedOptions() {
      return Array.from(this.querySelectorAll('input[type="radio"]:checked, select')).map((i) => i.value);
    }
    match() {
      const sel = this.selectedOptions;
      return this.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    }
    onChange() {
      const variant = this.match();
      const root = this.closest('[data-product-root]') || document;
      const idInput = root.querySelector('input[name="id"]');
      const button = root.querySelector('[data-add-button]');

      if (!variant) {
        if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = t.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (button) {
        button.toggleAttribute('aria-disabled', !variant.available);
        button.textContent = variant.available ? t.strings.addToCart : t.strings.soldOut;
      }
      const priceEl = root.querySelector('[data-price]');
      if (priceEl) {
        priceEl.innerHTML = variant.compare_at_price > variant.price
          ? '<span class="price__was">' + money(variant.compare_at_price) + '</span><span class="price__now">' + money(variant.price) + '</span>'
          : money(variant.price);
        priceEl.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
      }
      const sku = root.querySelector('[data-sku]');
      if (sku) sku.textContent = variant.sku || '';

      if (variant.featured_media) {
        const media = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        media && media.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      window.history.replaceState({}, '', this.url + '?variant=' + variant.id);
    }
  }
  customElements.define('variant-picker', VariantPicker);

  /* ---------- quantity + line item ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      const next = Math.max(parseInt(input.min || 0, 10), parseInt(input.value, 10) + parseInt(step.dataset.qtyStep, 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      Cart.change({ line: parseInt(remove.dataset.lineRemove, 10), quantity: 0 });
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    Cart.change({ line: parseInt(input.dataset.lineQty, 10), quantity: parseInt(input.value, 10) });
  });

  /* ---------- carousel rail ---------- */
  class ProductRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rail__track');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      this.bar = this.querySelector('.rail__progress i');
      if (!this.track) return;
      this.prev && this.prev.addEventListener('click', () => this.scrollBy(-1));
      this.next && this.next.addEventListener('click', () => this.scrollBy(1));
      this.track.addEventListener('scroll', this.update.bind(this), { passive: true });
      window.addEventListener('resize', this.update.bind(this));
      this.update();
    }
    step() {
      const first = this.track.firstElementChild;
      if (!first) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    scrollBy(dir) {
      const perView = Math.max(1, Math.round(this.track.clientWidth / this.step()));
      this.track.scrollBy({ left: dir * this.step() * perView, behavior: 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const pct = max > 0 ? this.track.scrollLeft / max : 0;
      if (this.bar) {
        const w = Math.max(0.12, this.track.clientWidth / this.track.scrollWidth);
        this.bar.style.width = w * 100 + '%';
        this.bar.style.transform = 'translateX(' + (pct * (100 / w - 100)) + '%)';
      }
      this.prev && this.prev.toggleAttribute('disabled', this.track.scrollLeft <= 2);
      this.next && this.next.toggleAttribute('disabled', this.track.scrollLeft >= max - 2);
    }
  }
  customElements.define('product-rail', ProductRail);

  /* ---------- announcement rotator ---------- */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = $$('.announcement__item', this);
      if (this.items.length < 2 || this.dataset.rotate !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0;
      const speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.timer = setInterval(() => {
        this.items[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % this.items.length;
        this.items[i].setAttribute('aria-hidden', 'false');
      }, speed);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  /* ---------- video band ---------- */
  class VideoBand extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      const play = this.querySelector('[data-video-toggle]');
      const mute = this.querySelector('[data-video-mute]');
      play && play.addEventListener('click', () => {
        if (this.video.paused) { this.video.play(); play.dataset.state = 'playing'; }
        else { this.video.pause(); play.dataset.state = 'paused'; }
      });
      mute && mute.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        mute.dataset.state = this.video.muted ? 'muted' : 'unmuted';
      });
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting && this.dataset.autoplay === 'true') this.video.play().catch(() => {});
          else this.video.pause();
        });
      }, { threshold: 0.25 });
      io.observe(this);
    }
  }
  customElements.define('video-band', VideoBand);

  /* ---------- predictive search ---------- */
  class SiteSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-search-results]');
      if (!this.input) return;
      let timer;
      this.input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = this.input.value.trim();
        if (q.length < 2) { this.results.innerHTML = ''; return; }
        timer = setTimeout(() => this.fetch(q), 260);
      });
    }
    async fetch(q) {
      const url = t.routes.predictive_search_url +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article&resources[limit]=6&section_id=predictive-search';
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const node = doc.querySelector('#shopify-section-predictive-search');
      this.results.innerHTML = node ? node.innerHTML : '';
    }
  }
  customElements.define('site-search', SiteSearch);

  /* ---------- mobile nav accordions ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-mnav-toggle]');
    if (!toggle) return;
    const sub = toggle.nextElementSibling;
    const open = sub.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
  });

  /* ---------- facets ---------- */
  class FacetForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.addEventListener('change', () => this.apply());
    }
    async apply() {
      const params = new URLSearchParams(new FormData(this.form)).toString();
      const url = window.location.pathname + '?' + params;
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      ['#product-grid', '#facet-form', '.toolbar__count'].forEach((sel) => {
        const inc = doc.querySelector(sel), cur = $(sel);
        if (inc && cur) cur.innerHTML = inc.innerHTML;
      });
      window.history.pushState({}, '', url);
    }
  }
  customElements.define('facet-form', FacetForm);

  /* ---------- one entrance, on first view only ---------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        obs.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  }

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', () => {
    $$('.reveal').forEach((el) => el.classList.add('is-in'));
  });

  window.Cart = Cart;
})();
